import React from 'react';
import { CustomerUser } from '@ansvar-sakerhet/api-client';
import { useCustomerUsersTableData } from '../../hooks/useCustomerUsersTableData';
import { useTable } from 'react-table';
import { S } from './CustomerUsersTable.styles';
import { useDeleteCustomerUser } from '../../../../../../../../../../../traits/api/customerUsers/deleteCustomerUser';

export const CustomerUsersTable = ({
  customerUsers,
  onEdit,
}: {
  customerUsers: CustomerUser[];
  onEdit: (user: CustomerUser) => void;
}) => {
  const data = useCustomerUsersTableData(customerUsers);
  const table = useTable(data);
  const deleteCustomerUser = useDeleteCustomerUser();

  if (customerUsers.length === 0) {
    return <S.B1>Det finns inga kund-användare att visa.</S.B1>;
  }

  return (
    <S.TableContainer>
      <S.AltTable {...table.getTableProps()}>
        <S.AltTHead>
          {table.headerGroups.map((headerGroup) => (
            <S.AltTHeadRow
              {...headerGroup.getHeaderGroupProps()}
              key={headerGroup.getHeaderGroupProps().key}
            >
              {headerGroup.headers.map((column) => {
                return (
                  <S.AltTHeadCell
                    {...column.getHeaderProps()}
                    key={column.getHeaderProps().key}
                  >
                    <S.TableText>{column.render('Header')}</S.TableText>
                  </S.AltTHeadCell>
                );
              })}
            </S.AltTHeadRow>
          ))}
        </S.AltTHead>

        <S.AltTBody {...table.getTableBodyProps()}>
          {table.rows.map((row) => {
            table.prepareRow(row);
            const user = customerUsers.find(
              (u) => u.customerUserId === row.original.userId
            );

            return (
              <S.AltTBodyRow {...row.getRowProps()} key={row.getRowProps().key}>
                {row.cells.map((cell) => {
                  if (cell.column.id === 'events') {
                    return (
                      <S.AltTBodyCell
                        {...cell.getCellProps()}
                        key={cell.getCellProps().key}
                      >
                        <S.Actions>
                          <S.Button
                            type="button"
                            onClick={() => {
                              if (user) onEdit(user);
                            }}
                          >
                            Redigera
                          </S.Button>
                          <S.Button
                            type="button"
                            onClick={() => {
                              if (
                                !window.confirm(
                                  'Är du säker på att du vill ta bort denna kund-användare?'
                                )
                              ) {
                                return;
                              }
                              deleteCustomerUser.mutateAsync({
                                customerUserId: cell.row.original.userId,
                              });
                            }}
                          >
                            Ta bort
                          </S.Button>
                        </S.Actions>
                      </S.AltTBodyCell>
                    );
                  }

                  if (cell.column.id === 'userId') {
                    return null;
                  }

                  return (
                    <S.AltTBodyCell
                      {...cell.getCellProps()}
                      key={cell.getCellProps().key}
                    >
                      {cell.render('Cell')}
                    </S.AltTBodyCell>
                  );
                })}
              </S.AltTBodyRow>
            );
          })}
        </S.AltTBody>
      </S.AltTable>
    </S.TableContainer>
  );
};
